<template>
  <div class="app6" :class="{ app6White: isWhite }">
    <van-popup v-model="show" class="tishiTanchu">
      <div class="tishiContent">
        <div class="chaIcon" @click="noShowTishi">
          <img src="../assets/images/chaIcon.png" alt="" />
        </div>
        <div class="title">提示</div>
        <div class="secondWord">为保证定位的精确，务必开启</div>
        <div class="thirdWord">手机定位功能!</div>
        <div class="dibuBtn">
          <button @click="noShowTishi">好的，知道了</button>
        </div>
      </div>
    </van-popup>

    <div class="head" :class="{ headWhite: isWhite }">
      <van-search
        v-model="addressNameLike"
        placeholder="请输入关键词"
        @input="addListrLike"
        v-if="isOldShow"
        class="OldInput"
        :clearable="false"
      />

      <div class="NewInputZu" v-if="isNewInputShow">
        <van-search
          v-model="addressNameLike"
          placeholder="请输入关键词"
          @input="addListrLike"
          class="NewInput"
          :clearable="false"
        />
        <p @click="clearInput">取消</p>
      </div>

      <ul class="navList" v-if="isOldShow">
        <li class="leftSel everyNav">
          <div class="word" @click="showAreaPopup">
            <span v-show="isMorenShow">{{ morenMsg }}</span>
            {{ checkedArea }}
          </div>
          <div class="xiajian">
            <img src="../assets/images/arrowdown.svg" alt="" />
          </div>
          <van-popup
            v-model="areaPopup"
            position="bottom"
            round
            :style="{ height: 'auto' }"
            class="areaPopup"
          >
            <div class="biaoqian">
              <ul>
                <li
                  class="allArea"
                  @click="checkArea('')"
                  :class="checkedArea == '' ? 'active' : ''"
                >
                  全部区域
                </li>
                <li
                  @click="checkArea('张浦镇')"
                  :class="checkedArea == '张浦镇' ? 'active' : ''"
                >
                  张浦镇
                </li>
                <li
                  @click="checkArea('玉山镇')"
                  :class="checkedArea === '玉山镇' ? 'active' : ''"
                >
                  玉山镇
                </li>
              </ul>
              <ul>
                <li
                  @click="checkArea('巴城镇')"
                  :class="checkedArea === '巴城镇' ? 'active' : ''"
                >
                  巴城镇
                </li>
                <li
                  @click="checkArea('周市镇')"
                  :class="checkedArea === '周市镇' ? 'active' : ''"
                >
                  周市镇
                </li>
                <li
                  @click="checkArea('陆家镇')"
                  :class="checkedArea === '陆家镇' ? 'active' : ''"
                >
                  陆家镇
                </li>
              </ul>
              <ul>
                <li
                  @click="checkArea('开发区')"
                  :class="checkedArea === '开发区' ? 'active' : ''"
                >
                  开发区
                </li>
                <li
                  @click="checkArea('千灯镇')"
                  :class="checkedArea === '千灯镇' ? 'active' : ''"
                >
                  千灯镇
                </li>
                <li
                  @click="checkArea('花桥镇')"
                  :class="checkedArea === '花桥镇' ? 'active' : ''"
                >
                  花桥镇
                </li>
              </ul>
              <ul>
                <li
                  @click="checkArea('周庄镇')"
                  :class="checkedArea === '周庄镇' ? 'active' : ''"
                >
                  周庄镇
                </li>
                <li
                  class="allArea"
                  @click="checkArea('淀山湖镇')"
                  :class="checkedArea === '淀山湖镇' ? 'active' : ''"
                >
                  淀山湖镇
                </li>
                <li
                  @click="checkArea('锦溪镇')"
                  :class="checkedArea === '锦溪镇' ? 'active' : ''"
                >
                  锦溪镇
                </li>
              </ul>
            </div>
            <div class="fenge"></div>
            <div class="dibu" @click="hideAreaPopup">取消</div>
          </van-popup>
        </li>
        <li class="rightSel everyNav">
          <div class="word" @click="showJuliPopup">
            <span v-show="isLiwozuijin">{{ liwoMsg }}</span>
            <span v-show="ischeckedDistance">{{ checkedDistance }}m</span>
          </div>
          <div class="xiajian">
            <img src="../assets/images/arrowdown.svg" alt="" />
          </div>
          <van-popup
            v-model="juliPopup"
            position="bottom"
            round
            :style="{ height: 'auto' }"
            class="juliPopup"
          >
            <div class="biaoqian">
              <ul>
                <li
                  class="liwo"
                  @click="checkDistance('')"
                  :class="checkedDistance === '' ? 'active' : ''"
                >
                  离我最近
                </li>
                <li
                  class="wubai"
                  @click="checkDistance('500')"
                  :class="checkedDistance == '500' ? 'active' : ''"
                >
                  500m
                </li>
                <li
                  class="yiqian"
                  @click="checkDistance('1000')"
                  :class="checkedDistance == '1000' ? 'active' : ''"
                >
                  1000m
                </li>
              </ul>
              <ul class="second">
                <li
                  class="erqian"
                  @click="checkDistance('2000')"
                  :class="checkedDistance == '2000' ? 'active' : ''"
                >
                  2000m
                </li>
                <li
                  class="wuqian"
                  @click="checkDistance('5000')"
                  :class="checkedDistance == '5000' ? 'active' : ''"
                >
                  5000m
                </li>
              </ul>
            </div>
            <div class="fenge"></div>
            <div class="dibu" @click="hideJuliPopup">取消</div>
          </van-popup>
        </li>
      </ul>
    </div>
    <div class="noContent" v-show="addrList.length == 0">
      <div class="noContentImg">
        <img src="../assets/images/noAddr.png" alt="" />
      </div>
      <div class="word">无符合条件的服务网点</div>
    </div>
    <div class="container6" :class="{ container6White: isWhite }">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        class="addrList"
        offset="150"
        :immediate-check="false"
      >
        <van-cell v-for="item in addrList" :key="item.id" class="inAddress">
          <div class="addIntr">
            <div class="addname">{{ item.addressname }}</div>
            <div class="addBuchong">
              <div class="addrIcon">
                <img src="../assets/images/addricon.svg" alt="" />
              </div>
              <div class="addjuti">{{ item.addressinfo }}</div>
            </div>
          </div>
          <div class="juli">
            <div
              class="juliIcon"
              @click="goMap(item.lng, item.lat, item.addressname)"
            >
              <img src="../assets/images/gohere.svg" alt="" />
            </div>
            <div class="juliNum">{{ item.distance }}</div>
          </div>
        </van-cell>
      </van-list>
    </div>

    <div class="wule" v-if="isBottomTipShow && addrList.length !== 0">
      <div class="leftStyle">
        <div class="shadowLine left"></div>
      </div>
      <span> <img src="../assets/images/lines2.svg" alt="" /></span>
      <div class="centerWord">没有更多了</div>
      <span> <img src="../assets/images/lines2.svg" alt="" /></span>
      <div class="rightStyle">
        <div class="shadowLine right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { doRem } from "../utils/setrem";
import Vue from "vue";
import { Search } from "vant";
import { DropdownMenu, DropdownItem } from "vant";
import { List } from "vant";
import { Dialog } from "vant";
import { Icon } from "vant";
import { Popup } from "vant";
import { Toast } from "vant";
import bridge from "../common/bridge";

Vue.use(Popup);
Vue.use(Icon);

Vue.use(List);

Vue.use(DropdownMenu);
Vue.use(DropdownItem);

Vue.use(Search);

export default {
  mounted() {

    this.getLocation();
  },
  data() {
    return {
      isWhite: false,
      isOldShow: true,
      isBottomTipShow: false,
      isNewInputShow: false,

      areaPopup: false,
      juliPopup: false,

      addressNameLike: "",

      checkedServiceType: 1,
      checkedDistance: "",
      liwoMsg: "离我最近",
      UserLng: "",
      UserLat: "",

      areaType: 0,
      checkedArea: "",
      morenMsg: "全部区域",
      isMorenShow: true,
      isLiwozuijin: true,
      ischeckedDistance: false,

      addrList: [],
      loading: false,
      finished: false,
      pageLimit: 10,
      currentPage: 1,
      show: false,
    };
  },
  methods: {
    noShowTishi() {
      this.show = false;
    },
    getLocation() {
      let that = this;
      var geolocation = new BMap.Geolocation();
      geolocation.enableSDKLocation();
      geolocation.getCurrentPosition(
        function (r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            // map.addOverlay(mk);
            // map.panTo(r.point);

            // 判断用户是否允许授权

            console.log("百度定位您的坐标：" + r.point.lng + "," + r.point.lat);
            that.UserLng = r.point.lng;
            that.UserLat = r.point.lat;
            that.show = true;
            that.getAddrList();
          } else {
            Dialog.alert({
              message: "为了给您推荐附近的网点，请开启手机定位服务！",
            }).then(() => {});
          }
        },
        { enableHighAccuracy: true }
      );
    },
    getToken() {
      let token = this.$route.query.token;
      if (!token == "") {
        localStorage.setItem("token", token);
      }
    },
    goMap(lng, lat, name) {
      // console.log(lng, lat, name);
      this.src = `https://api.map.baidu.com/marker?location=${lat},${lng}&title=${name}&content=${name}&output=html&src=webapp.baidu.openAPIdemo`;
      // window.open('https://www.baidu.com/', "_self");
      console.log(this.src);
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        lat,
        lng,
        name,
      };
      if (isiOS) {
        bridge.callhandler("setLngAndLat", data, (data) => {
          console.log(data);
        });
      }

      if (isAndroid) {
        var str = JSON.parse(
          window.ServiceAddrInterface.setLngAndLat(this.src, lat, lng, name)
        );
      }
    },
    addListrLike() {
      this.isOldShow = false;
      this.isNewInputShow = true;
      this.isWhite = true;
      this.currentPage = 1;
      this.addrList = [];
      this.finished = false;
      this.loading = false;
      this.getAddrList();
    },

    clearInput() {
      this.addressNameLike = "";
      this.isOldShow = true;
      this.isNewInputShow = false;
      this.isWhite = false;
      this.currentPage = 1;
      this.addrList = [];
      this.finished = false;
      this.loading = false;
      this.getAddrList();
    },

    showAreaPopup() {
      this.areaPopup = true;
    },
    showJuliPopup() {
      this.juliPopup = true;
    },

    hideAreaPopup() {
      this.areaPopup = false;
    },
    hideJuliPopup() {
      this.juliPopup = false;
    },

    checkArea(checkedArea) {
      // 改变选定的地区背景色

      if (checkedArea.length == 0) {
        this.isMorenShow = true;
        this.areaPopup = false;
        this.checkedArea = checkedArea;
        this.currentPage = 1;
        // 清空历史数据
        this.addrList = [];
        this.finished = false;
        this.loading = false;

        // 查询数据
        this.getAddrList();
      } else {
        this.isMorenShow = false;
        this.checkedArea = checkedArea;
        this.areaPopup = false;

        // 改变列表按钮的地区值

        // 页数回到第一页
        this.currentPage = 1;
        // 清空历史数据
        this.addrList = [];
        this.finished = false;
        this.loading = false;

        // 查询数据
        this.getAddrList();
      }
    },
    checkDistance(checkedDistance) {
      if (checkedDistance.length == 0) {
        this.isLiwozuijin = true;
        this.ischeckedDistance = false;
        this.juliPopup = false;
        this.checkedDistance = checkedDistance;
        this.currentPage = 1;
        // 清空历史数据
        this.addrList = [];
        this.finished = false;
        this.loading = false;

        // 查询数据
        this.getAddrList();
      } else {
        this.isLiwozuijin = false;
        this.ischeckedDistance = true;
        this.checkedDistance = checkedDistance;
        this.juliPopup = false;

        // 改变列表按钮的地区值

        // 页数回到第一页
        this.currentPage = 1;
        // 清空历史数据
        this.addrList = [];
        this.finished = false;
        this.loading = false;

        // 查询数据
        this.getAddrList();
      }
    },

    getAddrList() {
      Toast.loading({
        message: "网点查询中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        pageindex: this.currentPage,
        pagesize: this.pageLimit,
        type: this.checkedServiceType,
        addressarea: this.checkedArea,
        addressname: this.addressNameLike,
        distance: this.checkedDistance,
        lng: this.UserLng,
        lat: this.UserLat,
      });

      this.$axios
        .post("appapi/branch/distributionList", params)
        .then((res) => {
          if (res.data.result !== 1) {
             Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            console.log(res);
           
            Toast.clear();
            if (res.data.distributionList.length == 0) {
              this.finished = true;
              this.isBottomTipShow = true;
            }
            res.data.distributionList.forEach((item) => {
              if (item.distance > 1000) {
                let num = item.distance / 1000;
                item.distance = num.toFixed(1) + "km";
              } else {
                item.distance = item.distance + "m";
              }
              this.addrList.push(item);
              this.loading = false;
            });
          }
        })
        .catch((err) => {
          console.error(err);
           Toast.clear();
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
      this.currentPage++;
    },

    onLoad() {
      this.getAddrList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/ServiceAddr.scss";
.leftSel {
  margin-right: 6.25rem;
}
</style>

<style lang="scss" scoped>
.headWhite,
.app6White {
  background-color: #ffffff;
}
.container6White {
  background-color: #ffffff;
  margin-top: 8.25rem;
}

.head ::v-deep .OldInput {
  height: 5rem;
  background: #ffffff;
  padding: 0;
  border-radius: 2.5rem;
  .van-search__content {
    border-radius: 2.5rem;
    padding-left: 2.625rem;
    background: #ffffff;

    .van-cell {
      padding: 0;

      .van-cell__value--alone .van-field__body .van-field__control {
        font-size: 1.75rem;
        color: #878787;
        margin-left: 0.625rem;
      }

      .van-field__left-icon .van-icon {
        font-size: 2.5rem;
        color: #878787;
      }
    }
  }
}

.NewInputZu {
  display: flex;
  align-items: center;
  p {
    font-size: 1.75rem;
    color: #338989;
    margin-left: 1.75rem;
    white-space: nowrap;
  }
}
.head ::v-deep .NewInput {
  width: 36.625rem;
  height: 5rem;
  background: #f9f9f9;
  padding: 0;
  border-radius: 2.5rem;
  .van-search__content {
    border-radius: 2.5rem;
    padding-left: 2.625rem;
    background: #f9f9f9;

    .van-cell {
      padding: 0;

      .van-cell__value--alone .van-field__body .van-field__control {
        font-size: 1.75rem;
        color: #878787;
        margin-left: 0.625rem;
      }

      .van-field__left-icon .van-icon {
        font-size: 2.5rem;
        color: #878787;
      }
    }
  }
}

.inAddress ::v-deep .van-cell__value--alone {
  display: flex;
  justify-content: space-between;
  .juli {
    font-size: 1.625rem;
    padding-top: 0.3125rem;
    .juliIcon {
      display: flex;
      justify-content: center;
    }
    img {
      width: 4.375rem;
      height: 4.375rem;
    }
  }
  .addIntr {
    width: 60%;
    .addname {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: 1.875rem;
      color: #19212a;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .addBuchong {
      width: 100%;
      color: #878787;
      font-size: 1.625rem;
      display: flex;
      align-items: center;
      margin-top: 0.625rem;
      .addrIcon {
        margin-top: 0.75rem;
      }

      .addrIcon img {
        width: 1.625rem;
        height: 2rem;
      }

      .addjuti {
        font-size: 1.625rem;
        margin-left: 0.75rem;
        color: #555555;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.inAddress :last-child {
  border: none !important;
}
.tishiTanchu {
  width: 90%;
  border-radius: 1.875rem;
  .tishiContent {
    position: relative;
    padding: 2.375rem 2.625rem 3.375rem 2.625rem;
    .chaIcon {
      position: absolute;
      right: 2.625rem;
      top: 2.625rem;
      img {
        width: 1.625rem;
        height: 1.625rem;
      }
    }
    .title {
      text-align: center;
      color: #338989;
      font-size: 2.5rem;
      font-weight: 900;
      line-height: 3.625rem;
    }
    .secondWord {
      text-align: center;
      color: #19212a;
      font-size: 2rem;
      line-height: 3.5rem;
      margin-top: 3rem;
    }
    .thirdWord {
      text-align: center;
      color: #19212a;
      font-size: 2rem;
      line-height: 3.5rem;
    }
    .dibuBtn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 2.375rem;
      button {
        padding: 1.125rem 6.125rem;
        white-space: nowrap;
        background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
        color: #ffffff;
        font-size: 2rem;
        line-height: 2.875rem;
        border: none;
        border-radius: 2.5rem;
        font-weight: 900;
      }
    }
  }
}
</style>